const ChatPageSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
      <path
        d="M2.65723 5.60088C2.65723 4.89884 2.93611 4.22556 3.43252 3.72915C3.92893 3.23274 4.60221 2.95386 5.30425 2.95386H14.5688C15.2708 2.95386 15.9441 3.23274 16.4405 3.72915C16.9369 4.22556 17.2158 4.89884 17.2158 5.60088V10.8949C17.2158 11.5969 16.9369 12.2702 16.4405 12.7666C15.9441 13.2631 15.2708 13.5419 14.5688 13.5419H11.9218L7.95126 17.5125V13.5419H5.30425C4.60221 13.5419 3.92893 13.2631 3.43252 12.7666C2.93611 12.2702 2.65723 11.5969 2.65723 10.8949V5.60088Z"
        fill="white"
      />
      <path
        d="M19.6884 8.15332V10.8003C19.6884 12.2044 19.1592 13.551 18.2173 14.5438C17.2753 15.5366 15.9978 16.0944 14.6657 16.0944H13.1941L10.9766 18.433C11.3281 18.6302 11.7287 18.7414 12.1544 18.7414H14.6657L18.4327 22.7119V18.7414H20.944C21.6101 18.7414 22.2488 18.4625 22.7198 17.9661C23.1908 17.4697 23.4554 16.7964 23.4554 16.0944V10.8003C23.4554 10.0983 23.1908 9.42503 22.7198 8.92861C22.2488 8.4322 21.6101 8.15332 20.944 8.15332H19.6884Z"
        fill="white"
      />
    </svg>
  );
};

export default ChatPageSvg;
